import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import isNil from 'lodash/isNil';
import {
  pluralize,
} from '@populateui/utils';
import ToolTip from 'core/components/Tooltip';
import ClockIcon from 'core/icons/clock';
import {
  getWaitTime,
} from 'pages/Dashboard/pages/Encounters/pages/List/utils/helper';

export type WaitTimeType = {
  hours: number;
  minutes: number;
};

type Props = {
  patientEnteredInOfficeTime: string;
};

export default function WaitTime({ patientEnteredInOfficeTime }: Props) {
  const [waitTime, setWaitTime] = useState<WaitTimeType | null>(null);

  useEffect(() => {
    setWaitTime(getWaitTime(patientEnteredInOfficeTime));
    const intervalId = setInterval(() => {
      setWaitTime(getWaitTime(patientEnteredInOfficeTime));
    }, 60 * 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  const waitTimeLabel = useMemo(() => {
    const timeInHours = waitTime?.hours ? pluralize('hour', waitTime.hours) : '';
    const timeInMinutes = waitTime?.minutes ? pluralize('min', waitTime?.minutes) : '';
    return `${timeInHours} ${timeInMinutes}`.trim();
  }, [waitTime]);

  const showWaitTime = !isNil(waitTime) && (waitTime?.hours > 0 || waitTime?.minutes > 0);

  return showWaitTime ? (
    <>
      <ToolTip title={`Waiting for ${waitTimeLabel}`}>
        <span className="relative -top-0.5">
          <ClockIcon className="!h-4 !w-4 !text-blue-500" />
        </span>
      </ToolTip>
      <p className="text-xs font-semibold text-gray-500 self-center truncate !ml-2 small:hidden">
        {waitTimeLabel}
      </p>
    </>
  ) : null;
}
